import { CodeError } from '@iotize/common/error';
import { SinglePacket } from '@iotize/tap/service/impl/single-packet';

export class DataLoggerError extends CodeError<DataLoggerError.Code> {
  constructor(
    code: DataLoggerError.Code,
    msg: string,
    public cause?: Error,
  ) {
    super(msg, code);
  }

  static decodePacketError(singlePacket: SinglePacket, cause: Error) {
    return new DataLoggerError.CannotDecodePacketError(singlePacket, cause);
  }

  static notAuthorizedToPerformAction(msg: string, cause: Error) {
    return new DataLoggerError(
      DataLoggerError.Code.ActionUnauthorizedError,
      msg,
      cause,
    );
  }
}

export namespace DataLoggerError {
  export class CannotDecodePacketError extends DataLoggerError {
    constructor(
      public singlePacket: SinglePacket,
      cause: Error,
    ) {
      super(
        Code.DecodePacketError,
        `Cannot parse data log packet. Error: ${cause.message}`,
        cause,
      );
    }
  }

  export enum Code {
    DecodePacketError = 'DataLoggerErrorDecodePacket',
    ActionUnauthorizedError = 'DataLoggerErrorActionUnauthorized',
  }
}
